import type { ReactNode } from 'react';

/** A failed submit, shown in the form the user is looking at instead of a toast. */
export function FormError({ children }: { children?: ReactNode }) {
  if (!children) return null;
  return (
    <p role="alert" className="text-sm text-destructive">
      {children}
    </p>
  );
}
